<template>
  <el-dialog class="dialog-create-plan" :title="pageType === 'add' ? '信息发布' : '编辑信息发布'" :visible.sync="dialogVisible"
    :before-close="handleBeforeClose" width="850px">
    <div class="wrap">
      <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">
        <el-form-item label="标题 :" prop="activityName">
          <el-input v-model="form.activityName" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
        </el-form-item>

        <el-form-item label="活动地点 :" prop="activityPlace">
          <el-input v-model="form.activityPlace" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
        </el-form-item>

        <el-form-item label="活动名额 :" prop="activityQuota">
          <el-input v-model="form.activityQuota" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
        </el-form-item>

        <!-- <el-form-item label="活动时间 :" prop="activityTime1">
          <el-date-picker v-model="littleTime" placeholder="选择日期时间" type="datetimerange" format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item> -->

        <el-form-item label="开始时间 :" prop="activityTime">
          <el-date-picker style="width: 100%;" v-model="form.activityTime" format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择时间"></el-date-picker>
        </el-form-item>

        <el-form-item label="结束时间 :" prop="activityEndTime">
          <el-date-picker style="width: 100%;" v-model="form.activityEndTime" format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择时间"></el-date-picker>
        </el-form-item>

        <el-form-item class="avatar-uploader-form m-upload-box" label="封面图 :">
          <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" accept="image/*" :data="configData"
            :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
            <img v-if="imgUrl" style="height:150px;width:100%;object-fit:contain;" :src="imgUrl" class="avatar">
            <div v-else>
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <div class="el-upload__text">上传图片</div>
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item label="活动要求 :" prop="activityDemand">
          <el-input v-model="form.activityDemand" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
        </el-form-item>

        <el-form-item label="年龄范围 :">
          <div style="display: flex">
            <el-select v-model="form.startAge" @clear="clearStartAge" clearable
              placeholder="请选择">
              <el-option v-for="item in ageNumList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            <span style="display: inline-block;width:6%;text-align:center"> - </span>
            <el-select v-model="form.endAge" @clear="clearEndAge" clearable
              placeholder="请选择">
              <el-option v-for="item in ageNumList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <!-- <el-form-item label="年龄范围 :">
          <div style="display: flex">
            <el-select v-model="form.startAge" @change="startAgeChange" @clear="setStartAgeList" clearable
              placeholder="请选择">
              <el-option v-for="item in startAgeList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            <span style="display: inline-block;width:6%;text-align:center"> - </span>
            <el-select v-model="form.endAge" @change="endAgeChange" @clear="setEndAgeList" clearable
              placeholder="请选择">
              <el-option v-for="item in endAgeList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </div>
        </el-form-item> -->

        <!-- <el-form-item label="最小年龄 :" prop="startAge">
          <el-input v-model="form.startAge" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
        </el-form-item>

        <el-form-item label="最大年龄 :" prop="endAge">
          <el-input v-model="form.endAge" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
        </el-form-item> -->

        <el-form-item label="活动费用 :" prop="activityCost">
          <el-input v-model="form.activityCost" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
        </el-form-item>

        <!-- <el-form-item label="排序 :" prop="sequence">
          <el-input type="number" v-model="form.sequence" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
        </el-form-item> -->

        <el-form-item label="预约须知 :" prop="activityNotice">
          <cmp-ckeditor ref="myCkeditor1" :defaultMsg="form.activityNotice" :id="`ue1`" :height="300"></cmp-ckeditor>
        </el-form-item>

        <el-form-item label="活动详情 :" prop="activityContent">
          <cmp-ckeditor ref="myCkeditor2" :defaultMsg="form.activityContent" :id="`ue1`" :height="300"></cmp-ckeditor>
        </el-form-item>

      </el-form>
    </div>

    <div slot="footer" class="footer mt-30" v-if="pageType !== 'detail'">
      <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">确定</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { validate } from '@/utils/util'
import cmpUploadProgress from '@cmp/my-upload/upload-progress' // 上传组件
import cmpCkeditor from '@cmp/editor/ckeditor'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['imageTypes']),
  },
  components: {
    cmpUploadProgress,
    cmpCkeditor
  },
  data() {
    // let validateReceiptNumber = (rule, value, callback) => {
    //   if (!validate(value, 'numDecimal')) {
    //     return callback(new Error('最多支持两位小数'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      loadingSave: false,
      pageType: 'add', // 页面类型 add 新增  edit 编辑  detail 详情
      detailId: '', // 用户id
      form: {},
      typeList: [],
      dialogVisible: false,
      configData: {
        tableName: 'appoint'
      },
      imgUrl: '',
      rules: {
        // scope: [
        //   { required: true, message: '必填', trigger: 'blur' },
        //   // { min: 1, max: 30, message: '请输入1到30个字符', trigger: 'blur' }
        // ],
        activityName: [{ required: true, message: '必填', trigger: 'blur' }],
        activityPlace: [{ required: true, message: '必填', trigger: 'blur' }],
        activityQuota: [{ required: true, message: '必填', trigger: 'blur' }],
        activityTime: [{ required: true, message: '必填', trigger: 'blur' }],
        activityEndTime: [{ required: true, message: '必填', trigger: 'blur' }],
      },
      scopeList: [],
      // 1 乐学堂 2 青少年研学 3 培训班 4 辽博讲堂 5 博淡雅集 6 辽博手作 7 亲子活动 8 其他公益活动
      apiObj: {
        '1': {
          detailApi: '/activitynew/personal/happy/find',
          addApi: '/activitynew/personal/happy/save',
          editApi: '/activitynew/personal/happy/update',
        },
        '2': {
          detailApi: '/activitynew/personal/youth/find',
          addApi: '/activitynew/personal/youth/save',
          editApi: '/activitynew/personal/youth/update',
        },
        '3': {
          detailApi: '/activitynew/personal/training/find',
          addApi: '/activitynew/personal/training/save',
          editApi: '/activitynew/personal/training/update',
        },
        '4': {
          detailApi: '/activitynew/personal/lecture/find',
          addApi: '/activitynew/personal/lecture/save',
          editApi: '/activitynew/personal/lecture/update',
        },
        '5': {
          detailApi: '/activitynew/personal/discourse/find',
          addApi: '/activitynew/personal/discourse/save',
          editApi: '/activitynew/personal/discourse/update',
        },
        '6': {
          detailApi: '/activitynew/personal/handicrafts/find',
          addApi: '/activitynew/personal/handicrafts/save',
          editApi: '/activitynew/personal/handicrafts/update',
        },
        '7': {
          detailApi: '/activitynew/personal/treasure/find',
          addApi: '/activitynew/personal/treasure/save',
          editApi: '/activitynew/personal/treasure/update',
        },
        '8': {
          detailApi: '/activitynew/personal/community/find',
          addApi: '/activitynew/personal/community/save',
          editApi: '/activitynew/personal/community/update',
        }
      },

      startAgeList: [],
      endAgeList: [],

      ageNumList: []
    }
  },
  methods: {
    init(type, id, fromType) {
      this.dialogVisible = true
      // 清空弹框数据
      this.form = {}
      this.pageType = type // 页面类型
      this.detailId = id || '' // 详情id
      this.fromType = fromType || '1' // 1 展演预约 2 特展预约 3 讲解预约

      this.setAgeNumList()
      this.setAgeList() // todo dele
      this.$nextTick(() => {
        this.$refs.myCkeditor1.initEditor()
        this.$refs.myCkeditor2.initEditor()
        this.$refs['form'].clearValidate() // 清空验证状态
      })

      // 新增或编辑
      if (this.detailId) {
        this.getDetailData()
      }
    },

    // 获取详情
    getDetailData() {
      this.$http
        .get(this.apiObj[this.fromType].detailApi, {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.form = res.result
            if (res.result.picture) {
              this.imgUrl = res.result.file && res.result.file.attPath

              this.form.img = res.result.picture
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },

    setAgeNumList() {
      this.ageNumList = []
      for (let m = 0; m < 100; m++) {
        this.ageNumList.push(m)
      }
    },
    clearStartAge() {
      this.form.startAge = null
    },
    clearEndAge() {
      this.form.endAge = null
    },

    setAgeList() {
      this.startAgeList = []
      this.endAgeList = []
      for (let m = 0; m < 100; m++) {
        this.startAgeList.push(m)
        this.endAgeList.push(m)
      }
    },

    startAgeChange(val) {
      this.endAgeList = this.endAgeList.filter(item => {
        return item > val
      })
    },

    endAgeChange(val) {
      this.startAgeList = this.startAgeList.filter(item => {
        return item < val
      })
    },

    setStartAgeList() {
      this.startAgeList = []
      if (this.form.endAge) {
        for (let m = 0; m < this.form.endAge; m++) {
          this.startAgeList.push(m)
        }
      } else {
        for (let m = 0; m < 100; m++) {
          this.startAgeList.push(m)
        }
      }
    },
    setEndAgeList() {
      this.endAgeList = []
      if (this.form.startAge) {
        for (let m = this.form.startAge + 1; m < 100; m++) {
          this.endAgeList.push(m)
        }
      } else {
        for (let m = 0; m < 100; m++) {
          this.endAgeList.push(m)
        }
      }
    },

    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      // if (!isLt2M) {
      //   this.$message({
      //     message: '上传文件大小不能超过 2MB!',
      //     type: 'warning'
      //   })
      //   return
      // }

      if (this.imageTypes.includes(fileType)) {
        return true

      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        if (this.pageType == 'edit') {
          this.form.imgUrl = res.result.attPath
        }
        this.form.img = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },

    // 文件上传回调
    uploadCallback(fileStr) {
      this.form.fileIds = fileStr
    },

    // 保存
    fromSubmit(form) {
      let content = this.$refs.myCkeditor1.getContent() // 调用子组件方法
      if (!content) {
        this.$message.warning('请输入预约须知')
        return
      }
      let content2 = this.$refs.myCkeditor2.getContent() // 调用子组件方法
      if (!content2) {
        this.$message.warning('请输入活动详情')
        return
      }
      if (!this.form.img) {
        this.$message.warning('请上传图片')
        return
      }
      if(this.form.startAge > this.form.endAge){
        this.$message.warning('年龄范围选择有误')
        return
      }
      let apiUrl = this.pageType === 'add' ? this.apiObj[this.fromType].addApi : this.apiObj[this.fromType].editApi
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true
          this.$http
            .post(apiUrl, {
              ...this.form,
              picture: this.form.img,
              activityNotice: content,
              activityContent: content2
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                if (this.pageType === 'edit') {
                  this.$message.success('编辑成功')
                } else if (this.pageType === 'add') {
                  this.$message.success('创建成功')
                }
                this.cancel()
                this.$emit('refresh')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },

    // 取消
    cancel() {
      this.imgUrl = ""
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    },

    handleBeforeClose(done) {
      this.imgUrl = ""
      this.$refs['form'].resetFields()
      // this.$refs.myCkeditor1.setContent('')  // 处理编辑时偶尔不能渲染出富文本数据
      done()
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-create-plan {
  /deep/ .el-form-item {
    // &.avatar-uploader-form {
    //   display: flex;
    //   flex-direction: row;

    //   .el-form-item__content {
    //     margin-left: 0 !important;
    //     display: flex;
    //     flex: 1;

    //     .avatar-uploader {
    //       width: 50%;
    //       border: 1px dashed #8c939d;
    //       min-height: 150px;
    //       display: flex;
    //       flex-direction: column;
    //       justify-content: center;
    //       align-items: center;

    //       .el-upload {
    //         width: 100%;
    //         min-height: 150px;
    //         display: flex;
    //         flex-direction: column;
    //         justify-content: center;
    //         align-items: center;
    //       }

    //       .el-icon-plus {
    //         font-size: 20px;
    //       }

    //       .el-upload__text {
    //         line-height: 1;
    //       }
    //     }
    //   }
    // }
  }
}
</style>